<template>
    <div>
        <div class="col-md-1" v-for="domain in domains">
            <input :id="'domains_' + domain.id" type="checkbox" v-model="selected_domains" :value="domain.id">
            <label :for="'domains_' + domain.id" v-text="domain.name"></label>
        </div>

        <form :action="action_url" method="POST" class="validate-form inventory_form">
            <input type="hidden" name="_token" :value="csrf">
            <div class="clearfix">
                <div class="pull-right clearfix">
                    <input type="submit"
                           class="btn btn-primary inventory_submit"
                           :value="trans('save_button', null)"
                    >
                </div>
            </div>
            <br>
            <table class="b-warehouse__bonuses-table">
                <thead>
                    <tr>
                        <th class="col-md-3" v-text="trans('title')"></th>
                        <th class="col-md-2" v-text="trans('available_quantity')"></th>
                        <th class="col-md-2" v-text="trans('reserve')"></th>
                        <th class="col-md-2" v-text="trans('total_quantity')"></th>
                        <th class="col-md-2">
                            <span v-if = "section === 'inventory'" v-text="trans('new_quantity')"></span>
                            <span v-else v-text="trans('add_to_stock')"></span>
                        </th>
                        <th v-if = "section === 'inventory'" class="col-md-3" v-text="trans('comment')"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="bonus in filtered_bonuses">
                        <td class="col-md-3">
                            <span v-if="bonus.domain_id == 0"
                                  class="b-admin-domain__label all-domains"
                                  v-text="trans('all_domains')"
                            ></span>
                            <span v-else
                                  :class="'b-admin-domain__label ' + bonus.domain.template"
                                  v-text="bonus.domain.short_title">
                            </span>
                            &nbsp;
                            <span v-text="bonus.title"></span>
                        </td>
                      <td class="col-md-1">
                        <div>
                          <input type="hidden"
                                 :name="'data[' + bonus.id + '][available_quantity]'"
                                 :value="bonus.available_quantity"/>
                          <span v-text="bonus.available_quantity"></span>
                        </div>
                      </td>
                        <td class="col-md-1">
                            <input
                                    :name="'data[' + bonus.id + '][reserve]'"
                                    type="hidden"
                                    :value="bonus.calculatedReserve"/>
                            <span v-text="bonus.calculatedReserve"></span>
                        </td>
                        <td class="col-md-1">
                          <div>
                            <input type="hidden"
                                   :name="'data[' + bonus.id + '][old_total_quantity]'"
                                   :value="bonus.available_quantity + bonus.calculatedReserve"/>
                            <span v-text="bonus.available_quantity + bonus.calculatedReserve"></span>
                          </div>
                        </td>
                        <td class="col-md-2">
                            <input v-if = "section === 'inventory'"
                                    :name="'data[' + bonus.id + '][new_total_quantity]'"
                                    class="form-control input-sm b-warehouse__new-count"
                                    type="number"
                                    min="0"
                                    step="1"
                                    :value="bonus.available_quantity + bonus.calculatedReserve">
                            <input v-else
                                    :name="'data[' + bonus.id + '][quantity]'"
                                    class="form-control input-sm b-warehouse__new-count"
                                    type="number"
                                    min="0"
                                    step="1"
                                    value="0">
                        </td>
                        <td v-if = "section === 'inventory'" class="col-md-3">
                            <input
                                    :name = "'data[' + bonus.id + '][comment]'"
                                    class =" form-control input-sm b-warehouse__new-count"
                                    type = "text"
                                    :placeholder = "trans('comment')"
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pull-right">
                <br>
                <input type="submit"
                       class="btn btn-primary inventory_submit"
                       :value="trans('save_button', null)"
                >
            </div>
        </form>
    </div>
</template>

<script>
    let Functions = require("../../Functions");

    module.exports = {
        props: ['section', 'bonuses', 'domains', 'translations'],
        data: function () {
            return {
                csrf: '',
                selected_domains: [],
                action_url: "/warehouse/" + this.section + "/bonuses",
            };
        },
        mounted: function () {
            let token = document.querySelector('#token').getAttribute('content');
            Vue.http.headers.common['X-CSRF-TOKEN'] = token;
            this.csrf = token;
        },
        computed: {
            filtered_bonuses: function () {
                let self = this;
                return this.bonuses.filter(function (bonus) {
                    if (self.selected_domains.length !== 0) {
                        return self.in_selected_domains(bonus.domain_id);
                    }

                    return true;
                });
            }
        },
        methods: {
            trans(name, path = 'stock') {
                return Functions.trans(this.translations, name, path);
            },
            in_selected_domains: function (needle) {
                return this.selected_domains.join(',').indexOf(needle) >= 0;
            }
        }
    };
</script>